import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

/**
 * ScrollPercentage:
 *   - Display the number scroll value at the moment.
 */
export function ScrollPercentage(props) {
  return (
    <p className="scrolly-percentage" tabIndex={props.tabIndex}>
      {props.scrollValue}
    </p>
  );
}

ScrollPercentage.propTypes = {
  /**
   * The tabIndex for the component
   */
  tabIndex: PropTypes.number,
  /**
   * The numerical value representing the scroll value
   */
  scrollValue: PropTypes.number,
};

ScrollPercentage.defaultProps = {
  tabIndex: 0,
  scrollValue: 0,
};
